<template>
  <transition name="modal">
    <div class="modal-mask" :class="classes">
      <div class="modal-wrapper" @click.self="close">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="modal-header" :close="close"></slot>
          </div>

          <div class="modal-body" :style="bodyStyle">
            <slot name="modal-body"></slot>
          </div>

          <div
            v-if='this.$slots["modal-footer"]'
            class="modal-footer"
          >
            <slot name="modal-footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['classes', 'bodyStyle'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
